module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"retry":"再試行","upload_failed":"上傳失敗","ai_clothing_detected":"AI真人實穿照","ai_analyzing":"AI分析中..."}}')
  delete Component.options._Ctor
}
